import React from 'react'


const Footer = () => {
  return (
    <footer>
      <div className='footer-container'>
      </div>
    </footer>
  )
}

export default Footer